<script lang="ts">
import { defineComponent, h } from 'vue';

/**
 * CheckBox — multi-select indicator
 */
export default defineComponent({
  props: { checked: Boolean },
  setup(componentProps) {
    return () =>
      h('div', { class: ['check-box', { checked: componentProps.checked }] });
  },
});
</script>
